import { render, staticRenderFns } from "./RecProductionReport.vue?vue&type=template&id=52af3540&scoped=true"
import script from "./RecProductionReport.vue?vue&type=script&lang=js"
export * from "./RecProductionReport.vue?vue&type=script&lang=js"
import style0 from "./RecProductionReport.vue?vue&type=style&index=0&id=52af3540&prod&lang=scss&scoped=true"
import style1 from "./RecProductionReport.vue?vue&type=style&index=1&id=52af3540&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52af3540",
  null
  
)

export default component.exports